import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../locales/translations';
import { useMemo } from 'react';

export function useTexts() {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_MANAGEMENT_RESOLVED,
  );
  return useMemo(() => {
    return t<
      string,
      {
        states: {
          approved: string;
          rejected: string;
        };
        filters: {
          student: string;
          studentPlaceholder: string;
          studyPlanVersionName: string;
          studyPlanVersionNamePlaceholder: string;
          requestStateName: string;
          requestStateNamePlaceholder: string;
          search: string;
          clean: string;
        };
        table: {
          headers: {
            name: string;
            id: string;
            studyPlan: string;
            askedBy: string;
            status: string;
            resolvedBy: string;
            action: string;
          };
          viewDetailButton: string;
        };
        empty: {
          noResults: {
            title: string;
            body: string;
          };
          noSearch: {
            title: string;
            body: string;
          };
        };
        description: string;
      }
    >('resolvedRequests', {
      returnObjects: true,
    });
  }, [t]);
}
